// @ts-nocheck
import React, { ReactElement, useState, useMemo } from 'react'
import queryString from 'query-string'
import { useDispatch } from 'react-redux'
import logo from 'Shared/img/logo.png'
import { useTranslation } from 'react-i18next'
import { useForm, Controller } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useHistory } from 'react-router-dom'
import { APP } from 'Configs/App'
import { hidePartOfEmailWithStars } from 'Constants/functions'
import { Mobile, Desktop } from 'Shared/components/Responsive'
import {
  applicantUpdateEmail,
  applicantConfirmEmail,
} from 'Redux/actions/influencerActions'
import { IconSuccessfully, IconTikTok } from 'Stories/Icon/Icon.stories'
import { influencerBoard } from 'Router/routes'
import {
  GreenBtn,
  GreyBtnDisabled,
  WhiteGreyBtn,
} from 'Stories/Button/Button.stories'
import { DottedBtn } from 'Stories/DottedBtn/DottedBtn.stories'
import ava from 'Shared/img/ava.png'
import { errorsList } from './helpers/errorsLIst'
import { schema } from './helpers/schema'
import Status from './components/Status'
import { InfluencerRegisterEnum } from '../../Types'
import { FormDataProps } from './RegistartionProps'

import {
  LoginFieldsWrapper,
  Header,
  Logo,
  LoginTitle,
  TitleAccent,
  MainWrapper,
  Text1,
  Text2,
  Text3,
  SuccessCircle,
  StyledInput,
  FormText,
  Form,
  BtnWrapper,
  SearchResult,
  SearchFoto,
  SearchText,
  Search,
  SearchTextTitle,
  SuccessText,
  WrapperForIcon,
  Red,
  ConfirmationText,
  BtnsWrapper,
  Center,
  TikTokBtnLink,
  ErrorText,
  ErrorContainer,
  TextError,
} from './styles'

const getStatus = userStatus => {
  if (userStatus === InfluencerRegisterEnum.CONNECT)
    return InfluencerRegisterEnum.CONNECT

  if (userStatus === InfluencerRegisterEnum.CONNECTED)
    return InfluencerRegisterEnum.CONNECTED

  if (userStatus === InfluencerRegisterEnum.FORM)
    return InfluencerRegisterEnum.FORM

  if (userStatus === InfluencerRegisterEnum.CONFIRMATION)
    return InfluencerRegisterEnum.CONFIRMATION

  if (userStatus === InfluencerRegisterEnum.COMPLETED)
    return InfluencerRegisterEnum.COMPLETED

  if (userStatus === InfluencerRegisterEnum.ERROR)
    return InfluencerRegisterEnum.ERROR

  return InfluencerRegisterEnum.JOIN
}

const Registration: React.FC = (): ReactElement => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()

  const userData = useMemo(() => queryString.parse(location.search), [
    location.search,
  ])

  const avatar =
    typeof userData?.avatarUrl === 'string' ? userData?.avatarUrl : ava

  const [authError, setAuthError] = useState(false)
  const [registarationState, setRegistarationState] = useState<
    InfluencerRegisterEnum
  >(getStatus(userData.status))
  const [isConnecting, setIsConnecting] = useState(false)

  const {
    register,
    control,
    handleSubmit,
    watch,
    getValues,
    clearErrors,
    formState: { errors },
  } = useForm<FormDataProps>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    criteriaMode: 'firstError',
    resolver: yupResolver(schema),
  })

  const watchEmail = watch('email', '')

  const values = getValues()
  const applicantUpdateEmailHandler = () => {
    dispatch(
      applicantUpdateEmail(userData.authToken, values.email, error => {
        if (error) {
          setAuthError(true)
          return
        }

        setRegistarationState(InfluencerRegisterEnum.CONFIRMATION)
      })
    )
  }

  const applicantConfirmEmailHandler = () => {
    const confirmationToken = userData?.confirmationToken

    if (!confirmationToken) {
      setRegistarationState(InfluencerRegisterEnum.CONNECT)
      return
    }

    dispatch(
      applicantConfirmEmail(confirmationToken, (error, payload) => {
        if (error) {
          return
        }

        history.push(`${influencerBoard}`)
      })
    )
  }

  const handleClearErrors = () => {
    clearErrors(['email'])
    setAuthError(false)
  }

  const errorReflaction = (text: string | string[]): string => {
    const textToString: string =
      typeof text === 'string'
        ? text
        : text.reduce((acc, item) => acc + item, '')

    if (!errorsList?.[textToString]) return t(errorsList.default_error)
    return t(errorsList[textToString])
  }

  return (
    <MainWrapper>
      <Header>
        <Logo>
          <img alt="logo" src={logo} />
        </Logo>
      </Header>

      <LoginFieldsWrapper>
        {registarationState === InfluencerRegisterEnum.JOIN && (
          <>
            <LoginTitle>
              {t('influencer.becomeA')}&nbsp;
              <TitleAccent>{t('influencer.creator')}</TitleAccent>&nbsp;
              {t('influencer.atSoundCampaign')}
            </LoginTitle>
            <Text1>
              <div>{t('influencer.getRewardsByUsingTracksInYourVideos')}</div>
              <div>{t('influencer.toJoinAsACreator')}</div>
            </Text1>

            <GreenBtn
              color="green"
              onClick={() =>
                setRegistarationState(InfluencerRegisterEnum.CONNECT)
              }
            >
              {t('influencer.joinAsACreator')}
            </GreenBtn>
          </>
        )}

        {(registarationState === InfluencerRegisterEnum.CONNECT ||
          registarationState === InfluencerRegisterEnum.CONNECTED ||
          registarationState === InfluencerRegisterEnum.CONFIRMATION ||
          registarationState === InfluencerRegisterEnum.ERROR ||
          registarationState === InfluencerRegisterEnum.FORM) && (
          <Status status={registarationState} />
        )}

        {registarationState === InfluencerRegisterEnum.CONNECT && (
          <>
            {!authError && (
              <Text2>{t('influencer.useYourTikTokAccount')}</Text2>
            )}

            <TikTokBtnLink
              isConnecting={isConnecting}
              href={APP.TIKTOK_AUTH_API}
              onClick={() => setIsConnecting(true)}
            >
              <WrapperForIcon>
                <IconTikTok />
              </WrapperForIcon>

              {isConnecting
                ? t('influencer.connecting')
                : t('influencer.connectWithTikTok')}
            </TikTokBtnLink>
          </>
        )}

        {registarationState === InfluencerRegisterEnum.ERROR && (
          <>
            {!authError && (
              <Text2>{t('influencer.useYourTikTokAccount')}</Text2>
            )}

            {userData?.reason && (
              <ErrorContainer>
                <TextError>{errorReflaction(userData?.reason)}</TextError>
              </ErrorContainer>
            )}

            <TikTokBtnLink href={APP.TIKTOK_AUTH_API}>
              <WrapperForIcon>
                <IconTikTok />
              </WrapperForIcon>

              {t('influencer.connectWithTikTok')}
            </TikTokBtnLink>
          </>
        )}

        {registarationState === InfluencerRegisterEnum.CONNECTED && (
          <>
            {authError && <Red>{t('influencer.authorizationFailed')}</Red>}
            {!authError && (
              <Text3>{t('influencer.useYourTikTokAccount')}</Text3>
            )}
            <Search>
              {userData && (
                <SearchResult>
                  <SearchFoto>
                    <img alt="foto" src={avatar} />
                  </SearchFoto>
                  <SearchText>
                    <SearchTextTitle>{userData?.nickname}</SearchTextTitle>
                    <div>
                      {userData?.displayName
                        ? `${userData.displayName}.`
                        : null}
                      &nbsp;
                      {userData?.followers ? `${userData.followers}` : 0}&nbsp;
                      {Number(userData.followers) !== 1
                        ? t('influencer.followers')
                        : t('influencer.follower')}
                    </div>
                  </SearchText>
                </SearchResult>
              )}
            </Search>
            <GreenBtn
              color="green"
              onClick={() => setRegistarationState(InfluencerRegisterEnum.FORM)}
            >
              {t('influencer.continue')}
            </GreenBtn>
          </>
        )}

        {registarationState === InfluencerRegisterEnum.FORM && (
          <Form onSubmit={handleSubmit(applicantUpdateEmailHandler)}>
            <FormText>{t('influencer.enterYourValidEmail')}</FormText>
            <Controller
              name="email"
              control={control}
              defaultValue=""
              render={({ field: { onChange } }) => (
                <StyledInput
                  name="email"
                  type="email"
                  autoComplete="off"
                  searchError={!!errors?.email?.message || !!authError}
                  {...register('email')}
                  placeholder={t('influencer.email')}
                  onChange={onChange}
                  onFocus={handleClearErrors}
                  onTouchStart={handleClearErrors}
                />
              )}
            />
            {errors.email?.message ? (
              <ErrorText>{errors.email?.message}</ErrorText>
            ) : null}

            {authError ? <ErrorText>Email is already exist</ErrorText> : null}
            <BtnWrapper comment={false}>
              {!watchEmail?.length ||
              Object.keys(errors).length !== 0 ||
              authError ? (
                <GreenBtn disabled color="greyDisabled">
                  <Desktop>{t('influencer.sendConfirmationLink')}</Desktop>
                  <Mobile>{t('influencer.sendConfirmationLink')}</Mobile>
                </GreenBtn>
              ) : (
                <GreyBtnDisabled submit color="green">
                  <Desktop>{t('influencer.sendConfirmationLink')}</Desktop>
                  <Mobile>{t('influencer.sendConfirmationLink')}</Mobile>
                </GreyBtnDisabled>
              )}
            </BtnWrapper>
          </Form>
        )}

        {registarationState === InfluencerRegisterEnum.CONFIRMATION && (
          <>
            <ConfirmationText>
              {t('influencer.confirmationLinkWaSentTo')}&nbsp;
              {hidePartOfEmailWithStars('shar@soundcamps.com')}
            </ConfirmationText>
            <Center>{t('influencer.pleaseCheckYourEmail')}</Center>
            <BtnsWrapper>
              <DottedBtn
                content={t('influencer.sendAgain')}
                onClick={applicantUpdateEmailHandler}
              />
              <DottedBtn
                content={t('influencer.changeEmail')}
                onClick={() =>
                  setRegistarationState(InfluencerRegisterEnum.FORM)
                }
              />
            </BtnsWrapper>
          </>
        )}

        {registarationState === InfluencerRegisterEnum.COMPLETED && (
          <>
            <SuccessCircle>
              <IconSuccessfully />
            </SuccessCircle>
            <SuccessText>
              {t('influencer.yourAccountSuccessfulyAdded')}
            </SuccessText>

            <WhiteGreyBtn color="white" onClick={applicantConfirmEmailHandler}>
              {t('influencer.close')}
            </WhiteGreyBtn>
          </>
        )}
      </LoginFieldsWrapper>
    </MainWrapper>
  )
}

export default Registration
